import * as Actions from '../actions/actions';
import * as ActionTypes from '../actions/actiontypes';
import * as Service from '../services/services';
import { takeEvery, call, put } from 'redux-saga/effects';

export function* fetchRouteSummary(action) {
    try {
        const response = yield call(
            Service.getRouteSummary,
            action.payload.authToken,
            action.payload.filters
        );
        yield put(Actions.LOAD_ROUTE_SUMMARY_SUCCESS(response.data.data));
    } catch (error) {
        yield put(Actions.LOAD_ROUTE_SUMMARY_ERROR(error));
    }
}

export function* fetchRouteDetails(action) {
    try {
        const response = yield call(
            Service.getRouteDetails,
            action.payload.authToken,
            action.payload.filters
        );
        yield put(Actions.LOAD_ROUTE_DETAILS_SUCCESS(response.data.data));
    } catch (error) {
        yield put(Actions.LOAD_ROUTE_DETAILS_ERROR(error));
    }
}

export function* fetchDoorDetails(action) {
    try {
        const response = yield call(
            Service.getDoorDetails,
            action.payload.authToken,
            action.payload.filters
        );
        yield put(Actions.LOAD_DOOR_DETAILS_SUCCESS(response.data.data));
    } catch (error) {
        yield put(Actions.LOAD_DOOR_DETAILS_ERROR(error));
    }
}

export function* fetchRouteList(action) {
    try {
        const response = yield call(
            Service.getRouteList,
            action.payload.authToken,
            action.payload.filters
        );
        yield put(Actions.LOAD_ROUTE_LIST_SUCCESS(response.data.data || []));
    } catch (error) {
        yield put(Actions.LOAD_ROUTE_LIST_ERROR(error));
    }
}

export function* fetchDoorList(action) {
    try {
        const response = yield call(
            Service.getDoorList,
            action.payload.authToken,
            action.payload.filters
        );
        yield put(Actions.LOAD_DOOR_LIST_SUCCESS(response.data.data || []));
    } catch (error) {
        yield put(Actions.LOAD_DOOR_LIST_ERROR(error));
    }
}

export function* EffectListener() {
    yield takeEvery(ActionTypes.LOAD_ROUTE_SUMMARY, fetchRouteSummary);
    yield takeEvery(ActionTypes.LOAD_ROUTE_DETAILS, fetchRouteDetails);
    yield takeEvery(ActionTypes.LOAD_DOOR_DETAILS, fetchDoorDetails);
    yield takeEvery(ActionTypes.LOAD_ROUTE_LIST, fetchRouteList);
    yield takeEvery(ActionTypes.LOAD_DOOR_LIST, fetchDoorList);
}
